<template>
  <div class="AdminActivityList">
    <div class="container-fluid">
      <div class="table-responsive margin-Top-4Perc margin-left-0Point3Perc">
        <table class="table table-striped ">
          <thead>
            <tr>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Activity Data</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Activity Type</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Action Type</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Screen Name</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Date</th>    
            </tr>
          </thead>
          <tbody>
            <tr v-for="adminActivityObj in activityList" :key="adminActivityObj.ActivityId" v-bind:adminActivityObj = "adminActivityObj"> 
              <td class="text-align-center border-right padding-top-2Perc">{{adminActivityObj.ActivityData}}</td>
              <td class="text-align-center border-right padding-top-2Perc">{{getAdminActivityType($event,adminActivityObj.ActivityType)}}</td>
              <td class="text-align-center border-right padding-top-2Perc">{{getAdminActionType($event,adminActivityObj.AdminAction)}}</td>
              <td class="text-align-center border-right padding-top-2Perc">{{adminActivityObj.ScreenName}}</td>
              <td class="text-align-center border-right padding-top-2Perc">{{formatAndShowDate(adminActivityObj.CreatedTS)}}</td>
            </tr>
          </tbody>
       </table>
    </div>
  </div>
</div>
</template>

<script>
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['activityList'],
  data: function () {
    return {
    }
  },
  methods: {
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    getAdminActivityType: function (event, activityType) {
      var activityTypeName = ''
      switch (parseInt(activityType)) {
        case constants.AdminActivityType.Login:
          activityTypeName = 'Login'
          break
        case constants.AdminActivityType.Manage_Participant:
          activityTypeName = 'Manage Participant'
          break
        case constants.AdminActivityType.Manage_Course:
          activityTypeName = 'Manage Course'
          break
        case constants.AdminActivityType.Manage_GroupCourse:
          activityTypeName = 'Manage Group Course'
          break
        case constants.AdminActivityType.Manage_GroupCourseCohort:
          activityTypeName = 'Manage Group Course Cohort'
          break
        case constants.AdminActivityType.Manage_Steps:
          activityTypeName = 'Manage Steps'
          break
        case constants.AdminActivityType.Manage_Lessons:
          activityTypeName = 'Manage Lessons'
          break
        case constants.AdminActivityType.Manage_Challenges:
          activityTypeName = 'Manage Challenges'
          break
        case constants.AdminActivityType.Manage_MCQ:
          activityTypeName = 'Manage MCQ'
          break
        case constants.AdminActivityType.Manage_Emails:
          activityTypeName = 'Manage Emails'
          break
        case constants.AdminActivityType.Manage_Reports:
          activityTypeName = 'Manage Reports'
          break
        case constants.AdminActivityType.Manage_UserData:
          activityTypeName = 'Manage User Data'
          break
        case constants.AdminActivityType.Manage_Dashboard:
          activityTypeName = 'Manage Dashboard'
          break
        case constants.AdminActivityType.Manage_Files:
          activityTypeName = 'Manage Files'
          break
        case constants.AdminActivityType.Manage_MyProfile:
          activityTypeName = 'Manage My Profile'
          break
        case constants.AdminActivityType.Generic:
          activityTypeName = 'Generic'
          break
        case constants.AdminActivityType.Logout:
          activityTypeName = 'Logout'
          break
        case constants.AdminActivityType.Manage_UserActivity:
          activityTypeName = 'Manage User Activity'
          break
        case constants.AdminActivityType.Manage_AdminActivity:
          activityTypeName = 'Manage Admin Activity'
          break
        case constants.AdminActivityType.Manage_Group:
          activityTypeName = 'Manage Group'
          break
        case constants.AdminActivityType.Manage_Technique:
          activityTypeName = 'Manage Technique'
          break
        case constants.AdminActivityType.Manage_Topic:
          activityTypeName = 'Manage Topic'
          break
        case constants.AdminActivityType.Manage_Notification:
          activityTypeName = 'Manage Notification'
          break
        case constants.AdminActivityType.Update_User_Progress:
          activityTypeName = 'Update User Progress'
          break
        case constants.AdminActivityType.User_Request:
          activityTypeName = 'User Request'
          break
        case constants.AdminActivityType.List_Favorites:
          activityTypeName = 'List Favorites'
          break
        case constants.AdminActivityType.Toggle_Favorite:
          activityTypeName = 'Toggle Favorite'
          break
      }
      return activityTypeName
    },
    getAdminActionType: function (event, currActionType) {
      var actionType = ''
      switch (parseInt(currActionType)) {
        case constants.AdminActionType.Default:
          actionType = 'Default'
          break
        case constants.AdminActionType.Get:
          actionType = 'Get'
          break
        case constants.AdminActionType.Add:
          actionType = 'Add'
          break
        case constants.AdminActionType.Update:
          actionType = 'Update'
          break
        case constants.AdminActionType.Delete:
          actionType = 'Delete'
          break
        case constants.AdminActionType.ListAll:
          actionType = 'List All'
          break
        case constants.AdminActionType.FilteredList:
          actionType = 'Filtered List'
          break
        case constants.AdminActionType.ButtonClick:
          actionType = 'Button Click'
          break
        case constants.AdminActionType.LoadScreen:
          actionType = 'Load Screen'
          break
        case constants.AdminActionType.NavigationClick:
          actionType = 'Navigation Click'
          break
        case constants.AdminActionType.UpdateDashboardParams:
          actionType = 'Update Dashboard Params'
          break
        case constants.AdminActionType.Search:
          actionType = 'Search'
          break
        case constants.AdminActionType.SendMail:
          actionType = 'Send Mail'
          break
        case constants.AdminActionType.SendProgressionMail:
          actionType = 'Send Progression Mail'
          break
      }
      return actionType
    }
  },
  name: 'AdminActivityList'
}
</script>

<style scoped>
.AdminActivityList {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.margin-Top-4Perc
{
	margin-top: 4%;
}
.text-align-center {
 text-align: center !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.font-size-15px {
  font-size: 15px !important;
}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .padding-top-2Perc {
  padding-top: 2% !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}

</style>


// WEBPACK FOOTER //
// src/components/AdminActivityList.vue